import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const inputVariants = cva(
  "flex h-11 w-full rounded-[10px] border border-white/10 px-3 py-2 text-sm font-medium text-white [--input-autofill-text:#ffffff] caret-white ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-white/30 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 autofill:border-white/10 autofill:text-white autofill:shadow-none",
  {
    variants: {
      variant: {
        default: "bg-black-800 [--input-autofill-bg:var(--color-black-800)]",
        surface:
          "bg-black-600 [--input-autofill-bg:var(--color-black-600)] focus-visible:border-white/20 focus-visible:ring-0 focus-visible:ring-offset-0 aria-invalid:border-destructive",
        embedded:
          "border-0 bg-transparent shadow-none [--input-autofill-bg:transparent]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export type InputProps = React.ComponentProps<"input"> &
  VariantProps<typeof inputVariants>

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, variant, ...props }, ref) => {
    return (
      <input
        type={type}
        data-slot="input"
        data-variant={variant ?? "default"}
        className={cn(inputVariants({ variant }), className)}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input, inputVariants }
